<template>
  <div class="main">
    <tab title="对账"></tab>
    <div class="choose_time" v-if="state == 0">
      <div class="choose_title">请选择对账时间段</div>
      <div class="time_box">
        <div class="time">
          开始时间
          <div class="choose_box" @click="start_show = true">
            {{ start_time }}
          </div>
        </div>
        <div class="time">
          结束时间
          <div class="choose_box" @click="end_show = true">{{ end_time }}</div>
        </div>
      </div>
      <div class="choose_search" @click="setstate">开始对账</div>
    </div>
    <div v-if="state == 1">
      <div class="basic_info">
        <div class="info_title">基本信息</div>
        <div class="info_box">
          <div class="info">
            合作客户名称
            <div class="name_show">{{orgCustName}}</div>
          </div>
          <div class="info" style="margin-top: 15px">
            对账时间段　
            <div class="name_show">{{start_time}}~{{end_time}}</div>
          </div>
        </div>
      </div>
      <div class="the_detail">
        <div class="info_title">对账明细</div>
        <div class="info_box">
          <div class="info">
            账户余额
            <div class="name_show">{{balance}}元</div>
          </div>
        </div>
        <div class="table_box">
          <div class="table">
            <table border="0" cellpadding="0" cellspacing="0">
              <tr>
                <th colspan="3">充值对账</th>
              </tr>
              <tr class="tr_title">
                <td>充值次数</td>
                <td>充值金额</td>
                <td>当前账户余额</td>
              </tr>
              <tr class="tr_title">
                <td>{{dataCharge[0].chargeNum}}次</td>
                <td>{{dataCharge[0].chargeAmount}}元</td>
                <td>{{dataCharge[0].balance}}元</td>
              </tr>
            </table>
          </div>
          <div class="table">
            <table border="0" cellpadding="0" cellspacing="0">
              <tr>
                <th colspan="3">资金分配对账</th>
              </tr>
              <tr class="tr_title">
                <td>分配次数</td>
                <td>分配账户数</td>
                <td>总分配金额</td>
              </tr>
              <tr class="tr_title">
                <td>{{dataAssign[0].assignNum}}次</td>
                <td>{{dataAssign[0].assignAccNum}}个</td>
                <td>{{dataAssign[0].assignAmount}}元</td>
              </tr>
            </table>
          </div>
          <div class="table_b">
            <table border="0" cellpadding="0" cellspacing="0">
              <tr>
                <th colspan="4">卡加注对账</th>
              </tr>
              <tr class="tr_title">
                <td style="width:25% ;">加注总次数</td>
                <td>加注总升数</td>
                <td style="width:40% ;">加注总金额</td>
                <td>结算总金额</td>
                <td>子账户总余额</td>
              </tr>
              <tr class="tr_title">
                <td style="width:25% ;">{{dataOrder[0].orderCount}}次</td>
                <td>{{dataOrder[0].orderNum.toFixed(2)}}L</td>
                <td style="width:40% ;">{{(dataOrder[0].tradeAmount/100).toFixed(2)}}元</td>

                <td>{{dataOrder[0].orderAmount}}元</td>
                <td>{{dataOrder[0].balanceAll}}元</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="start_show" :round="true">
      <div class="timeChoose">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          title="选择开始时间"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="start_formatter"
          @confirm="start_confirm"
          @cancel="start_cancel"
        />
      </div>
    </van-popup>
    <van-popup v-model="end_show" :round="true">
      <div class="timeChoose">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          title="选择结束时间"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="start_formatter"
          @confirm="end_confirm"
          @cancel="end_cancel"
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import tab from "@/components/NavBar";
import Vue from "vue";
import { Toast } from "vant";
import { Popup } from "vant";
import { DatetimePicker } from "vant";

Vue.use(DatetimePicker);

Vue.use(Popup);

Vue.use(Toast);

export default {
  data() {
    return {
      state: 1,
      start_show: false,
      end_show: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      start_time: "",
      end_time: "",

      dataCharge: [],
      dataAssign: [],
      dataOrder: [],
      balance: "",
      orgCustName: "",
    };
  },
  components: {
    tab,
  },
  mounted(options) {

    console.log(this.$route.params)
    this.start_time = this.$route.params.start_time
    this.end_time = this.$route.params.end_time
    this.getOrderDetailInfo()

  },
  methods: {
    setstate() {
      
      var startTime = this.dateToTimestamp(this.start_time)
      var endTime = this.dateToTimestamp(this.end_time)
      if(startTime<=endTime){
          this.state = 1;
          this.getOrderDetailInfo();
      }else{
          this.start_time = ''
          this.end_time = ''
          Toast('结束时间不能大于开始时间')
      }
      
    },
    start_cancel() {
      this.start_show = false;
    },
    start_confirm(val) {
      let year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let hour = val.getHours();
      let minute = val.getMinutes();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`;
      }
      console.log(`${year}-${month}-${day}-${hour}-${minute}`);
      this.start_time = `${year}-${month}-${day}`;
      this.start_show = false;
      return `${year}-${month}`;
    },
    end_cancel() {
      this.end_show = false;
    },
    end_confirm(val) {
      let year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let hour = val.getHours();
      let minute = val.getMinutes();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`;
      }
      console.log(`${year}-${month}-${day}-${hour}-${minute}`);
      this.end_time = `${year}-${month}-${day}`;
      this.end_show = false;
      return `${year}-${month}`;
    },
    start_formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    getOrderDetailInfo() {
      var data = {
        token: this.$storage.get("token"),
        startDate: this.start_time,
        endDate: this.end_time,
      };
      this.$api.post("app/getOrderDetailInfo", data, (response) => {
        if (response.status >= 200 && response.status < 300) {
          console.log(response.data);
          var data = response.data;
          if (data.msg == "success") {
              this.balance = (data.balance/100).toFixed(2)
              this.orgCustName = data.orgCustName
              var dataCharge = data.dataCharge
              dataCharge.forEach(element => {
                  element.balance = (element.balance/100).toFixed(2)
                  element.chargeAmount = (element.chargeAmount/100).toFixed(2)
              });
              this.dataCharge = dataCharge

              var dataAssign = data.dataAssign
              dataAssign.forEach(element => {
                  element.assignAmount = (element.assignAmount/100).toFixed(2)
              });
              this.dataAssign = dataAssign

              var dataOrder = data.dataOrder
              dataOrder.forEach(element => {
                  element.balanceAll = (element.balanceAll/100).toFixed(2)
                  element.orderAmount = (element.orderAmount/100).toFixed(2)
              });
              this.dataOrder = dataOrder
          }
        }
      });
    },
    dateToTimestamp(dateStr) {
        if (!dateStr) {
            return ''
        }
        let newDataStr = dateStr.replace(/\.|\-/g, '/')
        let date = new Date(newDataStr);
        let timestamp = date.getTime();
        return timestamp
    }
  },
};
</script>

<style scoped>
.main {
  background-color: #f7f8fa;
  height: 100vh;
  text-align: center;
}
.choose_time {
  width: 85%;
  height: 177px;
  padding: 0 20px;
  border-radius: 5px;
  background-color: #fff;
  margin: auto;
  margin-top: 114px;
  position: relative;
}
.choose_title {
  width: 160px;
  height: 57px;
  line-height: 76px;
  text-align: center;
  border-bottom: 1px solid #1989FA;
  color: #3fa9dc;
  margin: auto;
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 10px;
}
.time_box {
  /* display: flex; */
  width: 80%;
  margin: auto;
}
.time {
  margin-left: 5px;

  display: flex;
  line-height: 25px;
  margin-top: 15px;
}
.choose_box {
  height: 25px;
  width: 150px;
  border: 1px solid #3fa9dc;
  border-radius: 5px;
  margin-left: 5px;
}
.choose_search {
  width: 70px;
  height: 30px;
  border-radius: 5px;
  color: #fff;
  background-color: #1989FA;
  line-height: 30px;
  text-align: center;
  position: absolute;
  right: 20px;
  bottom: 10px;
}
.basic_info {
  width: 95%;
  height: 124px;
  padding: 0 20px;
  border-radius: 5px;
  background-color: #fff;
  margin: auto;
  margin-top: 34px;
  position: relative;
}
.info_title {
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #fff;
  position: absolute;
  top: -15px;
  left: 40%;
  border: 1px solid #1989FA;
  border-radius: 5px;
}
.info_box {
  overflow: hidden;
}
.info {
  width: 80%;
  line-height: 30px;
  margin: auto;
  display: flex;
  margin-top: 30px;
}
.name_show {
  width: 192px;
  height: 30px;
  /* border-radius: 5px; */
  border-bottom: 1px solid #ccc;
  margin-left: 5px;
  font-size: 14px;
}
.the_detail {
  width: 100%;
  min-height: 300px;
  border-radius: 5px;
  background-color: #fff;
  margin: auto;
  margin-top: 20px;
  position: relative;
}
.table_box {
  overflow: hidden;
}
.table {
  width: 90%;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 20px;
}
.table_b {
  width: 99%;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 20px;
}
table,
td,
th {
  width: 100%;
  border: 1px solid #ccc;
  text-align: center;
}
th {
  width: 100%;
  border: 2px solid #ccc;
  text-align: center;
  height: 30px;
}
.tr_title {
  width: 100%;
}
.tr_title td {
  width: 33%;
  height: 35px;
}
.timeChoose {
  width: 300px;
}
.table_b  .tr_title{
  display: flex;
}
.table_b table tr:nth-child(3){
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/reconciliation.vue